import { Button } from '@selina-finance/ui';
import { useNavigate } from 'react-router-dom';

import BackButton from '@src/ui/components/BackButton/BackButton';
import PenIcon from '@src/ui/components/Icons/PenIcon';

const TransitionView = () => {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col mx-auto max-w-400 w-full lg:max-w-none'>
            <div className='hidden lg:block mb-8'>
                <BackButton />
            </div>
            <div className='text-xl'>
                <div className='flex flex-col lg:flex-row-reverse lg:justify-end lg:gap-80'>
                    <div className='flex justify-center mt-8 mb-10 lg:mt-0'>
                        <PenIcon className='lg:h-80 lg:w-80' />
                    </div>
                    <div className='lg:w-365'>
                        <p className='text-28 leading-100 font-sora-bold lg:text-28 tracking-tighter'>
                            One last step - update some details
                        </p>

                        <div className='leading-6 mt-2 text-lg text-midnight-200'>
                            <p>
                                Your credit file is usually{' '}
                                <span className='font-bold'>
                                    4-6 weeks out of date,
                                </span>{' '}
                                so we’ll need you to update and fill in some
                                missing details.
                            </p>
                            <p className='pt-2'>
                                We’ll use this to tell you how much you can
                                save.
                            </p>
                            <p className='font-bold pt-2'>
                                This won't impact your eligibility or credit
                                score.
                            </p>

                            <footer className='mt-8'>
                                <Button
                                    size='large'
                                    color='secondary'
                                    className='font-bold w-full text-lg'
                                    onClick={() =>
                                        navigate('/eligibility/debt-con/input')
                                    }
                                >
                                    <span className='text-lg'>Continue</span>
                                </Button>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransitionView;
